
define('jst!shared/dropdown/_grouped_dropdown_items',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<% _.each(items, function(group) { %>\n  <li role="presentation" class="dropdown-header">\n    <%=group.label%>\n  </li>\n\n  <%-render(templates.item, { items: group.items })%>\n<% }); %>');
 });

